export const DNI_MACROS: any = {
  "cmetrics-south asian": "South Asians",
  "cmetrics-middle eastern": "Middle Eastern",
  "cmetrics-caucasian": "Caucasian",
  "cmetrics-east asian": "East Asians",
  "cmetrics-african american": "African American/Black",
  "cmetrics-hispanic": "Hispanic",
  "cmetrics-female": "Women",
  "cmetrics-male": "Men"
}

export const DEFAULT_FMAGIC: any = {
  "5fe04757677375000707d2a6": "Saw a successful exit",
  "5ebe4ca2af6c340007b131e9": "Founded a company",
  "5e5c1f18d7ec490007b3dc50": "Have a PhD",
  "5f0acfaad95ba70007c5313a": "Have a Blog",
  "5eb42040e300000007095b46": "Long-tenured employees",
  "5f0acfc5d95ba70007c5313b": "Have a personal website",
  "61016084fbb63720db194414": "Have startup experience",
  "5f0308ef6ae83d00076ef7e9": "Completed Vesting Period"
}

export const MACROS_GROUP_BY_CAT: any = {
  overall_exp: {
    "5ea7d31d0509490007fb50a1": "0 - 2 years",
    "5ea7d3310509490007fb50a3": "2 - 5 years",
    "5ea7d3b70509490007fb50b4": "5 - 8 years",
    "5e6177fab225e0000703618b": "8 - 12 years",
    "5edf2f5fd8ce82000711c2a8": "12 - 20 years",
    "5edf306fd8ce82000711c2d1": "20+ years"
  },
  curr_company_exp: {
    "60db29d00088dd2648d38fe7": "0 - 2 years",
    "60db292b0088dd21bcd38fd5": "2 - 4 years",
    "60db2a130088dd12aad38fec": "4 - 6 years",
    "60db2a450088ddd7e9d38ff2": "6 - 8 years",
    "603fb6d6e09f8d3151b979b7": "6+ months",
    "60db28300088dd8ad5d38fcb": "9+ months",
    "60db28c40088dd16c7d38fd4": "5+ years"
  },
  curr_company_growth: {
    "5ebbe73b5a84de00071f1d96": "Less Than 0% Growth",
    "5ebbeac05a84de00071f1db3": "0% - 2% Growth",
    "5ebbe4a75a84de00071f1c97": "2% - 15% Growth",
    "5ebb971a5a84de00071ef769": "More Than 15% Growth"
  },
  curr_company_emp_strength: {
    "5edf3948d8ce82000711c62b": "0 - 50 Employees",
    "5edf38fbd8ce82000711c613": "51 - 200 Employees",
    "5edf3892d8ce82000711c354": "201 - 500 Employees",
    "5edf385bd8ce82000711c343": "501 - 1,000 Employees",
    "5eb89ef084da7a0007db266a": "1001 - 10,000 Employees",
    "5eb89f7a84da7a0007db2674": "10,000+ Employees"
  },
  curr_funding_stage: {
    "5ea7d6a70509490007fb5106": "Early Stage",
    "5ea7d7040509490007fb510a": "Mid Stage",
    "5ea7d7730509490007fb510e": "Late Stage",
    "5eb3ba57d4d733000746ecfc": "Public",
  },
  ats_source: {
    "60d45a3bd782e23699df49d4": "Events",
    "60d45a6dd782e23b6edf4a18": "Inbound",
    "60d45a51d782e226d4df4a0b": "Others",
    "60d45a7dd782e25e27df4a1a": "Outbound",
    "60d45a83d782e20de1df4a1c": "Referral"
  },
  matches_by_magic: DEFAULT_FMAGIC,
  matches_by_degree: {
    "5e7277c2d46d5f000793a6dc": "Bachelors or equivalent",
    "5ff43743c6fda80007fee5e4": "Associates or equivalent",
    "618cc8feec1cd310a78b3e79": "Doctor of Medicine (MD)",
    "6177a0ec95ce66da27d4608e": "High School Diploma or equivalent",
    "61925f43b13e9eb224276c89": "Juris Doctor (Doctor of Law / Jurisprudence)",
    "5e97ef38bea2240007858976": "Master of Business Administration (MBA)",
    "5e5c1e9fd7ec490007b3dc4c": "Masters or equivalent",
    "5e5c1f18d7ec490007b3dc50": "PhD"
  },
  matches_by_major: {
    "617a34e395ce663ed9d4682b": "Accounting",
    "615ea8196af18c51d9641588": "Actuarial Science",
    "615ef5686af18c22766457d5": "Arts",
    "615d5b39db84b2445defff75": "Biology",
    "6076af926277563634708202": "Business",
    "615d5a5bdb84b268bdefff20": "Chemistry",
    "614ab392bf54e06055cd3660": "Communication",
    "5e727854d46d5f000793a76c": "Computer Science (CS)",
    "605d9aa57e9360f02f32be11": "Data Science / Analytics",
    "608abdf7010665d927a1a3b6": "Diet & Nutrition",
    "60655f64b1a23b7edb2216af": "Economics",
    "5e72793ed46d5f000793a84c": "Electrical Engineering (EE)",
    "5f282d7c28191900071b7e0a": "Finance",
    "608ab95601066551a3a1a236": "Health, Kinesiology & related",
    "6107e38f05e1b93e700d39c3": "Human Resources",
    "5e727988d46d5f000793a85e": "Information Technology (IT)",
    "618cf281ec1cd362f88b3f18": "Law",
    "5e727c82d46d5f000793b86b": "Machine Learning (ML)",
    "61655d1d95ce66633bd42583": "Management Information Systems (MIS)",
    "614ab2e4bf54e0a8fccd362d": "Marketing",
    "5eb487f7e300000007098dc7": "Mathematics",
    "605b4e3cb816666debe3e45c": "Mechanical",
    "618d134eec1cd378d68b3f90": "Medicine & related",
    "61b19400d703131527d13044": "Nursing",
    "5eb48ad8e300000007098df8": "Physics",
    "60d9e1b70088ddec6ad314b4": "Psychology",
    "606ef32267edfdbf0b3852b2": "Robotics",
    "5ebc30645a84de00071f953b": "Science, Technology, Engineering & Math (STEM)",
    "606eae6067edfdd9ae384d8b": "Statistics",
    "61080a9b05e1b90b0d0d56bf": "Visual Design / Interaction Design / Human-Computer Interaction",

  }
}

export const MATCHEST_BY_MAPPER:any = {
  matches_by_loc: { title: 'Matches By Location', column_title: "Locations", type: "top_locations" },
  matches_by_tz: { title: 'Matches By Timezone', column_title: "Timezones", type: "top_timezone"  },
  matches_by_title: { title: 'Matches By Job Title', column_title: "Job Titles", type: "top_job_titles"  },
  matches_by_company: { title: 'Matches By Company', column_title: "Companies", type: "top_curr_comps"  },
  matches_by_skill: { title: 'Matches By Skill', column_title: "Skills", type: "top_skills"  },
  matches_by_school: { title: 'Matches By School', column_title: "Schools", type: "top_schools" },
  matches_by_degree: { title: 'Matches by Degree', column_title: "Degrees", type: "top_degree" },
  // matches_by_major: { title: 'Matches by Major', column_title: "Major", type: "top_major" }
  matches_by_magic: { title: 'Matches by Findem Magic', column_title: "Findem Magics", type: "top_magic" },
  matches_by_language: { title: 'Matches by Language', column_title: "Languages", type: "top_language" },
}

export const LEFT_INFO_CONTENT: {
  [key: string]: {
    label: string,
    content: string
  }[]
} = {
  attributes: [{
    label: "Must-Have",
    content: "Attributes that are required by candidates within the talent pool."
  }, {
    label: "Nice- to- Have",
    content: "Attributes that are ideal, but are not required within the talent pool."
  // }, {
  //   label: "Findem Magic",
  //   content: "Findem curated attributes that help identify unique candidates from within the talent pool."
  }],
  overview: [{
    label: "Match Pool",
    content: "The total number of candidates matching your must-have attributes. Including all filtered matches."
  }, {
    label: "Gender & Ethnicity",
    content: "The diversity and inclusion attributes are based on probabilistic models derived from multiple data sources and are not self-identified."
  }, {
    label: "Top Locations",
    content: "The top locations of candidates in this talent pool who have a location listed on their profile."
  }, {
    label: "Top Timezones",
    content: "The top timezones of candidates in this talent pool based on the location listed on their profile."
  }, {
    label: "Findem Magic",
    content: "Findem curated attributes that help identify unique candidates from within the talent pool."
  }],
  insights: [{
    label: "Top Employers",
    content:"The top companies of candidates in this talent pool who have a company associated with their current position on their profile."
  }, {
    label: "Top Employers by Funding Stage",
    content: "The distribution of candidates in this talent pool based on the funding stage of their current employers."
  }, {
    label: "Top Schools",
    content: "The top schools of candidates in this talent pool who have a school associated with their profile."
  }, {
    label: "Top Skills",
    content: "The top skills of candidates in this talent pool who have a skill listed in the skills section of their profile."
  }],
  matches_by_loc: [{
    label: "Location",
    content: "Location is determined by the current location of the candidate."
  }, {
    label: "Matches",
    content: "The number of candidates at each location. A candidate's location is determined by the current location on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
  }, {
    label: "Top Employer",
    content: "The company with the largest number of candidates in this location."
  }, {
    label: "Top Experience",
    content: "The experience range of the largest number of candidates in this location."
  }],
  matches_by_tz: [{
    label: "Timezone",
    content: "Timezone is determined by the current location of the candidate."
  }, {
    label: "Matches",
    content: "The number of candidates at each location. A candidate's location is determined by the current location on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
  }, {
    label: "Top Experience",
    content: "The experience range of the largest number of candidates in this timezone."
  }],
  matches_by_title: [{
    label: "Job Title",
    content: "List of the most common job titles. Job titles are determined by the title listed on the candidate's current position on their profile."
  }, {
    label: "Matches",
    content: "The number of candidates who have this job title listed on the current position on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates with this title."
    }],
  overall_exp: [{
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates in this experience."
    }],
  curr_company_exp: [{
    label: "Matches",
    content: "The number of candidates who fall under one of the current company experience buckets. A candidate's current experience is calculated as the sum of all current."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates in this experience."
    }],
  matches_by_company: [{
    label: "Company",
    content: "Company is determined by the current positions a candidate has listed on their profile."
  }, {
    label: "Matches",
    content: "The number of candidates with a current position at this company listed on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates in this company."
    // }, {
  //   label: "Attrition",
  //   content: "The percentage change in the number of candidates working at this company at the end of last month, compared to the number working at this company one year prior. Growth rates are not provided if there were no candidates at this company in the prior year."
    }],
  curr_company_growth: [{
    label: "Company Growth Rate",
    content: "The percentage change in revenue of the company for this year, compared to the revenue of the company one year prior."
  }, {
    label: "Matches",
    content: "The number of candidates with a current position at a company that falls under one of the growth rates buckets."
  }, {
    label: "Top Employer",
    content: "Company with the largest number of candidates in this bucket."
  }],
  curr_company_emp_strength: [{
    label: "Company Employee Size",
    content: "Company employee size is determined by the total number of candidates having a current position at the company."
  }, {
    label: "Matches",
    content: "The number of candidates with a current position at a company that falls under one of the growth rates buckets."
  }, {
    label: "Top Employer",
    content: "Company with the largest number of candidates in this bucket."
  }],
  curr_funding_stage: [{
    label: "Company Funding Stage",
    content: "Company funding stage is determined by the latest funding round information available publicly."
  }, {
    label: "Matches",
    content: "The number of candidates with a current position at a company that falls under one of the company funding stage buckets."
  }, {
    label: "Top Employer",
    content: "Company with the largest number of candidates in this bucket."
    }],
  ats_source: [{
    label: "ATS Source",
    content: "The source of the candidate's application received by the ATS. It is determined by the source data field associated with that candidate stored in your ATS system."
  }, {
    label: "Matches",
    content: "The number of candidates from this talent pool who are already present in your ATS and have one of these sources."
  }, {
    label: "Top Employer",
    content: "Company with the largest number of candidates in this bucket."
  }],
  matches_by_skill: [{
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
  }, {
    label: "Your Employees",
    content: "The number of your employees who fall under one of the overall experience buckets."
    }],
  matches_by_industry: [{
    label: "Matches",
    content: "The number of candidates who have listed their current position at a company operating in this Industry."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates in this industry."
    }],
  matches_by_school: [{
    label: "Schools",
    content: "The schools a candidate has listed in the education section of their profile."
  },{
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates from this school."
    }],
  matches_by_degree: [{
    label: "Degree",
    content: "The degrees a candidate has listed in the education section of their profile."
  },{
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates having this degree."
    }],
  matches_by_major: [{
    label: "Major",
    content: "The majors a candidate has listed in the education section of their profile."
  },{
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates having this major."
    }],
  matches_by_magic: [{
    label: "Findem Magic",
    content: "These are specialized attributes that help identify unique and hidden candidates from the talent pool."
  }, {
    label: "Matches",
    content: "The number of candidates who fall under one of the overall experience buckets. A candidate's overall experience is calculated as the sum of all work experiences mentioned on their profile."
  }, {
    label: "Women % vs Men %",
    content: "The estimated percentage of Women or Men employees within this talent pool. The gender attribute is based on probabilistic models derived from multiple data sources and is not self-identified."
  }, {
    label: "Gender Gap",
    content: "The difference between the estimated percentage of Women and Men employees within this talent pool. Those with a lower gender gap are closer to a 50/50 gender split. A positive gap indicates more women than men; a negative gap indicates more men than women."
    }, {
      label: "Top Experience",
      content: "The experience range of the largest number of candidates in this findem magic attribute."
    }],
  campaign_report: [{
      label: "Contacted",
      content: "Total number of emails successfully sent via the campaign. Each email instance sent to a candidate within the campaign is counted towards this metric."
    }, {
      label: "Recipients",
      content: "Total number of candidates who have successfully received at least one email from this campaign."
    }, {
      label: "Opened",
      content: "Total number of recipients who opened one or more emails from this campaign. Each recipient can only count once for this metric."
    }, {
      label: "Clicked",
      content: "Total number of recipients who clicked any links present in one or more emails from this campaign. Each recipient can only count once for this metric."
    }, {
      label: "Replied",
      content: "Total number of recipients who replied back to your campaign."
    }, {
      label: "Interested",
      content: "Total number of replies that are tagged as interested."
    }],
    matches_by_language: []
}

export const LANG_PROFICIENCY: string [] = [
  "Native or bilingual",
  "Full professional",
  "Elementary",
  "Limited working",
  "Professional working",
  "Unclassified"
]


export const BAR_COLORS: string[] = [
  "#007acc",
  "#00a74a",
  "#ff4d4d",
  "#a940ff",
  "#00b7b7",
  "#ff9900",
  "#6b8e23"
]
export const BORDER_RADIUS = 10;
export const FULLY_ROUNDED: [number, number, number, number] = [BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS, BORDER_RADIUS];
export const LEFT_ROUNDED: [number, number, number, number] = [BORDER_RADIUS, 0, 0, BORDER_RADIUS];
export const RIGHT_ROUNDED: [number, number, number, number] = [0, BORDER_RADIUS, BORDER_RADIUS, 0];